/**
 * DisplayItem > Contest object.
 *
 * @typedef {Object} Contest
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {Integer} score The number of votes the item has received.
 * @property {String} publicWinnerStatus Unknown!
 */
class Contest {

	constructor(score, publicWinnerStatus) {

		this.score				= score;
		this.publicWinnerStatus	= publicWinnerStatus;
	}
}

export default Contest;